import { createSlice } from "@reduxjs/toolkit";

const rightPanelSlice = createSlice({
  name: "rightPanel",
  initialState: { isOpen: false, isExpanded: true, content: null },
  reducers: {
    openRightPanel: (state, action) => {
      state.content = action?.payload?.content;
      state.isOpen = true;
    },
    closeRightPanel: (state) => {
      state.content = null;
      state.isOpen = false;
    },
    expandRightPanel: (state) => {
      state.isExpanded = true;
    },
    collapseRightPanel: (state) => {
      state.isExpanded = false;
    },
  },
});

export const {
  openRightPanel,
  closeRightPanel,
  expandRightPanel,
  collapseRightPanel,
} = rightPanelSlice.actions;

export default rightPanelSlice.reducer;

export const selectIsRightPanelOpen = (state) => {
  return state.rightPanel.isOpen;
};

export const selectIsRightPanelExpanded = (state) => {
  return state.rightPanel.isExpanded;
};

export const selectRightPanelContent = (state) => {
  return state.rightPanel.content;
};
